import React from 'react';
import { useNavigate } from 'react-router-dom';
import './no-order-found.scss';

const NoOrderFound = (props) => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        flexWrap: 'wrap',
      }}
    >
      <div style={{ fontFamily: 'Inter Medium', fontSize: '20px', marginTop: '2%' }}>
        🧡 Hang in there! New orders can come in anytime
      </div>

      <div
        style={{
          fontFamily: 'Inter Medium',
          marginTop: '25px',
          letterSpacing: '0.5px',
        }}
      >
        {' '}
        We're working on introducing direct access to manufacturers, producers, and top wholesalers
        to help you reduce inventory costs.
      </div>
      <div>
        Would you be interested in an inbuilt feature that allows you to order directly from them?
      </div>

      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div
          style={{
            width: '100px',
            height: '100px',
            border: '1px solid black',
            margin: '10px',
            borderRadius: '5px',
          }}
        >
          Image 1
        </div>
        <div
          style={{
            width: '100px',
            height: '100px',
            border: '1px solid black',
            margin: '10px',
            borderRadius: '5px',
          }}
        >
          {' '}
          Image 2
        </div>
        <div
          style={{
            width: '100px',
            height: '100px',
            border: '1px solid black',
            margin: '10px',
            borderRadius: '5px',
          }}
        >
          {' '}
          Image 3
        </div>
      </div>

      <button> Browse Wholesalers</button>

      {/* <div className='no-order-found-actions'>
        <div
          className='no-order-found-action-card'
          onClick={() => navigate('/uploadmenuimage')}
          role='button'
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') navigate('/uploadmenuimage');
          }}
        >
          <div className='no-order-found-action-card__title-row'>
            <span className='no-order-found-action-card__title'>Get started with your menu</span>
            <div className='no-order-found-action-card__arrow'>›</div>
          </div>

          <div className='no-order-found-action-card__items'>
            <div className='no-order-found-action-card__item'>
              <div className='no-order-found-action-card__icon'>📷</div>
              <div className='no-order-found-action-card__item-text'>
                <span className='no-order-found-action-card__item-label'>Upload menu image</span>
                <span className='no-order-found-action-card__item-desc'>
                  Share your menu with customers in a few clicks
                </span>
              </div>
            </div>

            <div className='no-order-found-action-card__item'>
              <div className='no-order-found-action-card__icon'>📅</div>
              <div className='no-order-found-action-card__item-text'>
                <span className='no-order-found-action-card__item-label'>Schedule a meeting</span>
                <span className='no-order-found-action-card__item-desc'>
                  Book a time with our team to set up your store
                </span>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default NoOrderFound;
